// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__UHejZ","vLegacy":"SelectSecondary_vLegacy__2b28f","error":"SelectSecondary_error__2EZ7d","disabled":"SelectSecondary_disabled__hTbZ5"};